export interface Trend {
    key: string;
    label: string;
    unit: string;
    delta: string;
    avg: number;
    series: number[];
}

export const DAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

/** Dates shown under each weekday label, as in v1. */
export const DAY_NUMS = ['4', '5', '6', '7', '8', '9', '10'];

export const TRENDS: Trend[] = [
    {
        key: 'calories',
        label: 'Calories',
        unit: 'kcal',
        delta: '+4%',
        avg: 1712,
        series: [1520, 1610, 1580, 1690, 1710, 2340, 2210],
    },
    {
        key: 'carbohydrates',
        label: 'Carbs',
        unit: 'g',
        delta: '-3%',
        avg: 198,
        series: [171, 224, 165, 233, 149, 251, 243],
    },
    {
        key: 'protein',
        label: 'Protein',
        unit: 'g',
        delta: '+6%',
        avg: 84,
        series: [66, 71, 79, 84, 91, 108, 94],
    },
    {
        key: 'fat',
        label: 'Fat',
        unit: 'g',
        delta: '+2%',
        avg: 62,
        series: [49, 53, 58, 55, 61, 79, 88],
    },
    {
        key: 'fiber',
        label: 'Fiber',
        unit: 'g',
        delta: '-8%',
        avg: 21,
        series: [26, 22, 24, 19, 21, 15, 12],
    },
    {
        key: 'sugar',
        label: 'Sugar',
        unit: 'g',
        delta: '+11%',
        avg: 38,
        series: [22, 27, 24, 31, 29, 58, 64],
    },
];
